/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { DescriptionPage_UpsellType as UpsellTypes } from '__generated__/graphql-types';

import type UserAgent from 'js/lib/useragent';

import { Typography, Typography2 } from '@coursera/cds-core';

import { getUpsellCopy } from 'bundles/stackability-common/stackability-common-index';
import StackabilityCarousel from 'bundles/xddp/components/homepage/StackabilityCarousel';
import type { UpsellsByDegreeSlug } from 'bundles/xddp/types';

const styles = {
  root: css`
    padding: 36px 0;
  `,
  sectionHeader: css`
    padding-bottom: 26px;
    font-size: 28px;
  `,
  caption: css`
    padding-bottom: 52px;
  `,
};

type Props = {
  items: UpsellsByDegreeSlug;
  userAgent: UserAgent;
};

const BodySection = ({ text }: { text: string }) => (
  <Typography2 component="p" variant="bodyPrimary" className="p-b-3">
    {text}
  </Typography2>
);

const Headline = ({ text }: { text: string }) => (
  <React.Fragment>
    {/* eslint-disable-next-line @coursera-web/custom-rules/prefer-cds-typography2 -- FIXME: legacy; migrate to Typography2 */}
    <Typography variant="h2" css={styles.sectionHeader}>
      {text}
    </Typography>
  </React.Fragment>
);
const SingleStackability = ({ items, userAgent }: Props) => {
  if (!items || !items[0]) {
    return null;
  }
  const upsellCopy = getUpsellCopy().degreesConversion.degreeDescription;
  const upsellType = items[0].upsellType;
  return (
    <div data-testid="single-stackability-section">
      {upsellType === UpsellTypes.PartOf && (
        <React.Fragment>
          <Headline text={upsellCopy.partOfCopy.subHeader} />
          <BodySection text={upsellCopy.partOfCopy.bodyText} />
        </React.Fragment>
      )}
      {upsellType === UpsellTypes.OffersCredit && (
        <React.Fragment>
          <Headline text={upsellCopy.offersCreditCopy.subHeader} />
          <BodySection text={upsellCopy.offersCreditCopy.bodyText} />
          <BodySection text={upsellCopy.offersCreditCopy.disclaimer} />
        </React.Fragment>
      )}
      {upsellType === UpsellTypes.RelatedTo && (
        <React.Fragment>
          <Headline text={upsellCopy.relatedToCopy.subHeader} />
          <BodySection text={upsellCopy.relatedToCopy.bodyText} />
        </React.Fragment>
      )}
      <div>
        <StackabilityCarousel items={items} userAgent={userAgent} />
      </div>
    </div>
  );
};

export default SingleStackability;
